export class BulkImportConfigDto {
    excludeInOrganization: boolean;

    constructor(iBulkImportData: BulkImportConfigDto) {
        this.excludeInOrganization = iBulkImportData.excludeInOrganization;
    }

    static fromDocument(iBulkImportData: BulkImportConfigDto) {
        const bulkImportDataDto = new BulkImportConfigDto(iBulkImportData);
        return bulkImportDataDto;
    }
}
